
import { defineComponent } from "vue";
import TotalVolume from "@/components/Shared/StatisticsView/TotalVolume.vue";
import DonationCount from "@/components/Shared/StatisticsView/DonationCount.vue";
import TransactionSuccessRates from "@/components/Shared/StatisticsView/TransactionSuccessRates.vue";

export default defineComponent({
  name: "StatisticsView",
  components: {
    TotalVolume,
    DonationCount,
    TransactionSuccessRates,
  },
  data() {
    return {
      role: "Donor",
      basis: "Weekly",
      totalSurplusVolume: 1200,
      commonFoodType: {
        type: "Vegetables",
        percent: 48,
      },
      successRate: 86,
      governmentLevel: "Barangay",
      foodSurplusVolumeChartData: {
        labels: [
          "Vegetables",
          "Meat & Poultry",
          "Eggs & Dairy",
          "Fish & Seafood",
        ],
        datasets: [
          {
            label: "Food Surplus Volume",
            data: [47, 32, 15, 8],
            backgroundColor: [] as string[],
            borderColor: "",
            rotation: -45,
          },
        ],
      },
      donationCountChartData: {
        labels: ["TALAMBAN", "MABOLO", "MANDAUE", "LAHUG"],
        datasets: [
          {
            label: "Donations Per Location",
            data: [21, 14, 8, 6],
            backgroundColor: [] as string[],
            borderColor: "",
            color: "#ffffff",
          },
        ],
      },
      successRatesChartData: {
        labels: ["Successful", "Cancelled", "Aborted"],
        datasets: [
          {
            label: "Rate of Successful Transactions",
            data: [86, 10, 4],
            backgroundColor: [] as string[],
            borderColor: "",
            rotation: -45,
          },
        ],
      },
    };
  },
  methods: {
    exportAsCSV() {
      console.log("Exporting raw data as CSV now...");
    },
    exportAsExcel() {
      console.log("Exporting raw data as XLSX now...");
    },
  },
  computed: {
    figuresTheme(): string[] {
      return this.role !== "Administrator"
        ? ["#113333", "#45bf5D", "#56f576", "#6ef997"]
        : ["#ffffff", "#45bf5D", "#56f576", "#6ef997"];
    },
    donationsCount(): number | null {
      return this.role === "Administrator" ? 0 : null;
    },
    successfulTransactionsCount(): number | null {
      return this.role === "Administrator" ? 0 : null;
    },
  },
  created() {
    // Total Food Surplus Volume Figure Theming
    this.foodSurplusVolumeChartData.datasets[0].backgroundColor =
      this.figuresTheme;
    this.foodSurplusVolumeChartData.datasets[0].borderColor =
      this.role === "Donor" || this.role === "Charity" ? "#ffffff" : "#113333";
    // Donations Per Location Figure Theming
    this.donationCountChartData.datasets[0].backgroundColor = this.figuresTheme;
    // Rate of Successful Transactions Figure Theming
    this.successRatesChartData.datasets[0].backgroundColor =
      this.figuresTheme.slice(1);
    this.successRatesChartData.datasets[0].borderColor =
      this.role === "Donor" || this.role === "Charity" ? "#ffffff" : "#113333";
  },
});
